module.exports = __webpack_public_path__ + "static/media/field-bg.79099ece.jpg";